export class FormulationDataQualityInfoRequest {
    colorId: number;
    qualityNo?: number;
}
